import DesktopLogOut from "./DesktopLogOut.js";
import MobileLogOut from "./MobileLogOut.js";
import ShowMainNav from "./ShowMainNav.js";
import ShowOptions from "./ShowOptions.js";
const install = molten => {
  molten.addPlugin('Action', DesktopLogOut);
  molten.addPlugin('Action', MobileLogOut);
  molten.addPlugin('Action', ShowMainNav);
  molten.addPlugin('Action', ShowOptions);
};
export default {
  install
};